
import React from 'react';
import ValorisationContentSection from '@/components/valorisation/ValorisationContentSection';
import { getContentBlocks } from './ValoGuideData';

const ValoGuideContent = () => {
  const contentBlocks = getContentBlocks();

  return (
    <div className="bg-white">
      <ValorisationContentSection
        title="Guide de valorisation des déchets"
        subtitle="Conseils d'experts et innovations pour une gestion environnementale responsable"
        blocks={contentBlocks}
        className="bg-white py-16"
      />
      
      {/* Section d'introduction supplémentaire */}
      <section className="py-12 bg-gradient-to-r from-fabre-lightbeige to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-fabre-gray mb-6">
              Pourquoi choisir ValoGuide ?
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-fabre-green">
                <h4 className="font-bold text-fabre-gray mb-2">Expertise Reconnue</h4>
                <p className="text-gray-600 text-sm">Plus de 25 ans d'expérience dans la valorisation des déchets</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-fabre-green">
                <h4 className="font-bold text-fabre-gray mb-2">Solutions Personnalisées</h4>
                <p className="text-gray-600 text-sm">Accompagnement sur mesure selon vos besoins spécifiques</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-fabre-green">
                <h4 className="font-bold text-fabre-gray mb-2">Réseau National</h4>
                <p className="text-gray-600 text-sm">Présence sur tout le territoire français avec nos sites partenaires</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ValoGuideContent;
